<template>
  <UiCard>
    <div slot="title">
      <div class="title"
        >Тариф CARD: <div class="title_value">{{ name }}</div>
      </div>
    </div>

    <div slot="content">
      <UiCardContentLine v-for="(s, i) in services" :key="`s-${i}`" class="card_content_line">
        <span slot="title">{{ s.title }}</span>
        <span slot="value">{{ s.value }}</span>
      </UiCardContentLine>

      <UiCardContentTitle v-if="hasOptions" class="card_content_line">
        Подключенные услуги
      </UiCardContentTitle>
      <UiCardContentLine v-for="(o, k) in options" :key="`o-${k}`" class="card_content_line">
        <span slot="title">{{ o.title }}</span>
        <span slot="value">{{ o.value }}</span>
      </UiCardContentLine>
    </div>

    <div slot="footer">
      <UiCardContentLine class="card_content_line">
        <span slot="title">Платеж за 30 дней</span>
        <span slot="value">{{ total }}</span>
      </UiCardContentLine>
    </div>
  </UiCard>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import UiCardContentLine from '@/components/card/UiCardContentLine.vue'
import UiCardContentTitle from '@/components/card/UiCardContentTitle.vue'
import currentApplicationMixin from '../mixins/currentApplicationMixin'

import helpers from './helpers'

export default {
  components: { UiCard, UiCardContentLine, UiCardContentTitle },
  mixins: [currentApplicationMixin, helpers],
  computed: {
    name() {
      return this.getValue('tariffcard.name') || '—'
    },
    services() {
      return [
        {
          title: 'Стоимость',
          value: this.getFormattedValue(this.getValue('tariffcard.cost')),
        },
        {
          title: 'Создание карты',
          value: this.getFormattedValue(this.getValue('tariffcard.cardCost')),
        },
        {
          title: 'Обслужение за 30 дней',
          value: this.getFormattedValue(this.getValue('tariffcard.cardCostMonth')),
        },
        {
          title: 'Отправка push',
          value: this.getFormattedValue(this.getValue('tariffcard.pushCost')),
        },
      ]
    },

    hasOptions() {
      return this.options && this.options.length
    },
    options() {
      const options = this.getValue('tariffoptions') || []

      return options
        .filter((o) => o.type === 1)
        .map((o) => {
          return {
            title: o.name,
            value: this.getFormattedValue(o.cost),
          }
        })
    },

    total() {
      const cost = parseFloat(this.getValue('tariffcard.cost'))
      const cardCostMonth = parseFloat(this.getValue('tariffcard.cardCostMonth'))

      // Total cost of options
      const options = this.getValue('tariffoptions') || []
      const optionsCost = options
        .filter((o) => o.type === 1)
        .map((o) => parseFloat(o.cost))
        .reduce((total, amount) => total + amount, 0)

      return this.getFormattedValue(cost + cardCostMonth + optionsCost)
    },
  },
}
</script>
